import DialogPlayerEvent from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/engine/player/DialogPlayerEvent";
import AppDialogPlayerEvent from "./AppDialogPlayerEvent";
import DefaultDialogPlayer from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/player/DefaultDialogPlayer";
import KeyDecisionContentEvent from "../../../key-decisions/event/KeyDecisionContentEvent";
import AppDialogPlayer from "./AppDialogPlayer";

export default class AppDefaultDialogPlayer extends DefaultDialogPlayer {
    constructor(timeTickInterval = 100) {
        console.log("AppDefaultDialogPlayer.constructor");
        super(timeTickInterval);

        this.dialogPlayer.addEventListener(AppDialogPlayerEvent.SKIP_DIALOG_OPTION, this.handleSkipDialogOption, this);
    }

    destroy() {
        this.dialogPlayer.removeEventListener(AppDialogPlayerEvent.SKIP_DIALOG_OPTION, this.handleSkipDialogOption);
        super.destroy();
    }

    
    createDialogPlayer() {
        this.dialogPlayer = new AppDialogPlayer(this.timeTickInterval);
    }

    handleSkipDialogOption({data}) {
        const keyDecisionContentEvent = new KeyDecisionContentEvent(KeyDecisionContentEvent.KEY_DECISION_CONTENT_IGNORED, data, this);
        this.dispatchEvent(keyDecisionContentEvent.type, { data: keyDecisionContentEvent });
    }
}